class BillApi {
    updateState(data) {
        var url = apiUrl + 'bills/state/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    getStatusTypes() {
        var url = apiUrl + 'bills/states';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    removeInvoiceDocument(id, documentId) {
        var url = apiUrl + 'bills/RemoveInvoiceDocument/' + id + '/' + documentId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

    removePaymentDocument(id, documentId) {
        var url = apiUrl + 'bills/RemovePaymentDocument/' + id + '/' + documentId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

    removeReceiptDocument(id, documentId) {
        var url = apiUrl + 'bills/RemoveReceiptDocument/' + id + '/' + documentId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }


    getListByCurrentBusiness(params = {}) {
        var url = apiUrl + 'bills/currentBusiness/';

        // Add includePayments parameter to load payment relationships
        const queryParams = {
            ...params,
            includePayments: true
        };

        console.log('[BillApi] getListByCurrentBusiness with params:', queryParams);

        return api.call('get', url, queryParams)
            .then(({ data }) => {
                console.log('[BillApi] getListByCurrentBusiness response:', {
                    totalRecords: data.totalRecords || data.result?.totalRecords,
                    sampleBill: data.data?.[0] || data.result?.data?.[0],
                    hasPayments: !!(data.data?.[0]?.payments || data.result?.data?.[0]?.payments)
                });
                return data
            });
    }


    getBillDataSet() {
        var url = apiUrl + 'bills/xmlList';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getList() {
        var url = apiUrl + 'bills';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }


    get(id) {
        var url = apiUrl + 'bills/';
        console.log('[BillApi] Fetching bill from:', url + id);
        return api.call('get', url + id)
            .then(({ data }) => {
                console.log('[BillApi] Raw response from GET /bills/' + id + ':', data);

                if (data.result && data.result.payments) {
                    console.log('[BillApi] Payments in response:', data.result.payments);
                    data.result.payments.forEach((payment, index) => {
                        console.log(`[BillApi] Payment #${index + 1}:`, {
                            id: payment.id,
                            amount: payment.amount,
                            documentPaymentProofId: payment.documentPaymentProofId,
                            hasDocumentPaymentProof: !!payment.documentPaymentProof,
                            documentPaymentProof: payment.documentPaymentProof
                        });
                    });
                } else {
                    console.log('[BillApi] No payments in response');
                }

                return data;
            });
    }
    getNext(id) {
        var url = apiUrl + 'bills/nextTo/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });

    }
    
    getPrev(id) {
        var url = apiUrl + 'bills/prevTo/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });

    }

    create(data) {
        var url = apiUrl + 'bills';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }
    update(data) {
        var url = apiUrl + 'bills/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'bills/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

    extractInvoiceData(documentId) {
        var url = apiUrl + 'bills/extract-invoice-data';
        return api.call('post', url, { documentId })
            .then(({ data }) => {
                return data
            });
    }

    // Payment Management
    getPayments(billId) {
        var url = apiUrl + 'bills/' + billId + '/payments';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    addPayment(billId, payment) {
        var url = apiUrl + 'bills/' + billId + '/payments';
        console.log('[BillApi] addPayment called with:', {
            billId,
            payment,
            paymentDate: payment.paymentDate,
            paymentDateType: typeof payment.paymentDate,
            paymentDateValue: payment.paymentDate ? payment.paymentDate.toString() : 'null',
            url
        });
        return api.call('post', url, payment)
            .then(({ data }) => {
                console.log('[BillApi] addPayment success:', data);
                return data
            })
            .catch((error) => {
                console.error('[BillApi] addPayment error:', {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status,
                    statusText: error.response?.statusText,
                    fullError: error
                });
                throw error;
            });
    }

    updatePayment(billId, paymentId, payment) {
        var url = apiUrl + 'bills/' + billId + '/payments/' + paymentId;
        return api.call('put', url, payment)
            .then(({ data }) => {
                return data
            });
    }

    deletePayment(billId, paymentId) {
        var url = apiUrl + 'bills/' + billId + '/payments/' + paymentId;
        return api.call('delete', url)
            .then(({ data }) => {
                return data
            });
    }

}

export default BillApi;